import { Box, styled, Typography } from "@mui/material";
import { FAIRTRADE_FONT_STACK } from "./constants";

export const PageTitle = styled(Typography)(() => ({
  fontWeight: 700,
  fontSize: '32px',
  fontFamily: FAIRTRADE_FONT_STACK,
  marginTop: '18px',
}))


export const PageWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  boxSizing: 'border-box',
  flexDirection: 'column',
  position: 'relative',
  marginLeft: 'auto',
  marginRight: 'auto',
  paddingBottom: '20px',
  width: '100%',
  maxWidth: '800px',
  fontFamily: FAIRTRADE_FONT_STACK,
  paddingLeft: '8px',
  // paddingRight: '6px',
  overflow: 'hidden',
  [theme.breakpoints.up('md')]: {
    paddingLeft: '24px',
    paddingRight: '24px',
  },
}))

export const InnerPageWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  boxSizing: 'border-box',
  flexDirection: 'column',
  width: '100%',
  paddingLeft: '6px',
  paddingRight: '6px',
  [theme.breakpoints.up('md')]: {
    paddingLeft: '0px',
    paddingRight: '0px',
  },
}))
